import { render, staticRenderFns } from "./vnsHexagonSubtitle.vue?vue&type=template&id=473a0593&scoped=true&"
import script from "./vnsHexagonSubtitle.vue?vue&type=script&lang=js&"
export * from "./vnsHexagonSubtitle.vue?vue&type=script&lang=js&"
import style0 from "./vnsHexagonSubtitle.vue?vue&type=style&index=0&id=473a0593&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473a0593",
  null
  
)

export default component.exports